import { Component } from '@angular/core';

interface AboutUsTab {
  labelKey: string;
  route: string;
}

@Component({
  selector: 'about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
})
export class AboutUsComponent {
  tabs: AboutUsTab[] = [
    { labelKey: 'ABOUT-US_TAB-MISSION', route: 'mission' },
    { labelKey: 'ABOUT-US_TAB-HISTORY', route: 'history' },
    { labelKey: 'ABOUT-US_TAB-BOARD', route: 'board-of-directors' },
  ];

  trackByRoute(_index: number, tab: AboutUsTab): string {
    return tab.route;
  }
}
